import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {useEntidad} from '../../hooks/useEntidad';
import InputEntidad from '../../common/InputEntidad';
import DireccionForm, {GetDataDireccion, IsValidDireccion} from '../DireccionForm';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import DireccionesRelacionadasGrid from '../DireccionesRelacionadasGrid';
import {isValidEmail} from '../../../utils/validator';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";

import {useFormErrors} from '../../hooks/useFormErrors';
import {Accordion, FormError, FormLabel} from "../../common";
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const ZonaEntregaModal = (props) => {

    const direccionInit = {
        id: props.data.entity.direccion.id,
        entidad: "ZonaEntrega",
        idEntidad: props.data.entity.direccion.idTemporal,
        idTipoGeoreferencia: props.data.entity.direccion.idTipoGeoreferencia,
        idPais: 0,
        idProvincia: 0,
        idLocalidad: 0,
        idZonaGeoreferencia: 0,
        codigoPostal: "",
        calle: "",
        entreCalle1: "",
        entreCalle2: "",
        altura: "",
        piso: "",
        dpto: "",
        referencia: "",
        longitud: 0,
        latitud: 0,
        origen: ""
    }

    const entityInit = {
        id: 0,
        idCuenta: 0,
        idTipoControlador: 0,
        email: "",
        direccion: direccionInit
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        showDireccionesRelacionadas: false,
        listDireccionesRelacionadas: null,
    });

    const [tipoControladorState, setTipoControladorState] = useState({
        isValidTipoControlador: false,
        isEmail: false,
    });

    const [tipoControladorEnUso, setTipoControladorEnUso] = useState([]);

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        setTipoControladorEnUso(props.data.tipoControladorEnUso);
        formSet({
            idTipoControlador: props.data.entity.idTipoControlador,
            email: props.data.entity.email,
            direccion: props.data.entity.direccion,
        });
    }

    useEffect(mount, [props.data.entity, props.data.vinculosTributo]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoControlador'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoControlador',
            timeout: 0
        }
    });

    const [formValues, formHandle, formReset, formSet] = useForm({
        idTipoControlador: 0,
        email: "",
        direccion: direccionInit
    });

    //handles
    const handleClickAceptar = () => {
        if (isFormValid()) {

            let row = CloneObject(state.entity);
            row.idTipoControlador = parseInt(formValues.idTipoControlador);

            row.direccion = !tipoControladorState.isEmail ? GetDataDireccion.get("ZonaEntrega_direccion")() : direccionInit;
            row.email = tipoControladorState.isEmail ? formValues.email : "";

            props.onConfirm(row);
        }
        ;
    };

    const handleClickDireccionesRelacionadas = () => {
        setState(prevState => ({...prevState, showDireccionesRelacionadas: true}));
    };

    const onSelected = (id, row) => {

        formSet({
            idTipoControlador: 1, // TODO: pongo este tipo de controlador por poner pero no se cual deberia ir
            direccion: {
                id: formValues.direccion.id,
                entidad: formValues.direccion.entidad,
                idEntidad: formValues.direccion.idEntidad,
                idTipoGeoreferencia: formValues.direccion.idTipoGeoreferencia,
                idPais: row.idPais,
                idProvincia: row.idProvincia,
                idLocalidad: row.idLocalidad,
                idZonaGeoreferencia: row.idZonaGeoreferencia,
                codigoPostal: row.codigoPostal,
                calle: row.calle,
                entreCalle1: row.entreCalle1,
                entreCalle2: row.entreCalle2,
                altura: row.altura,
                piso: row.piso,
                dpto: row.dpto,
                referencia: row.referencia,
                longitud: row.longitud,
                latitud: row.latitud,
                origen: ""
            },
        });

        setState(prevState => {
            return {...prevState, showDireccionesRelacionadas: false};
        });
    }

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoControlador <= 0) errors.idTipoControlador = VALIDATION_MESSAGE.REQUIRED_OPTION;

        if (tipoControladorState.isEmail && !formValues.email) errors.email = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    function getFormatErrors() {

        const errors = {};
        if (props.disabled) return errors;

        if (tipoControladorState.isEmail && formValues.email && !isValidEmail(formValues.email)) {
            errors.email = 'Ingresá un correo válido';
        }

        return errors;
    }

    function isFormValid() {

        if (!validate()) {
            return false;
        }

        if (!tipoControladorState.isEmail && tipoControladorState.isValidTipoControlador) {
            const isValidDireccion = IsValidDireccion.get("ZonaEntrega_direccion")();
            if (!isValidDireccion.result) {
                if (isValidDireccion.message) ShowToastMessage(ALERT_TYPE.ALERT_WARNING, isValidDireccion.message);
                return false;
            }
        }

        return true;
    }

    const getDescTipoControlador = (id) => {
        const row = getRowEntidad('TipoControlador', id);
        return (row) ? row.nombre : '';
    }

    function ValidateTipoControlador(entity) {
        if (entity.target && entity.target.row) {
            if (entity.target.row.email || entity.target.row.direccion) {
                setTipoControladorState(prevState => ({
                    ...prevState,
                    isEmail: entity.target.row.email,
                    isValidTipoControlador: true
                }));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "El tipo de controlador no es válido");
                setTipoControladorState(prevState => ({...prevState, isEmail: false, isValidTipoControlador: false}));
                formReset();
            }
        }
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Zona de entrega: ${(state.entity.id > 0) ? getDescTipoControlador(state.entity.idTipoControlador) : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.ZONA_ENTREGA_MODAL}
                onEscape={() => props.onDismiss()}
                body={(<>
                            {state.showDireccionesRelacionadas &&
                                <DireccionesRelacionadasGrid
                                    listDireccionesRelacionadas={props.data.listDireccionesRelacionadas}
                                    onDismiss={() => {
                                        setState(prevState => {
                                            return {...prevState, showDireccionesRelacionadas: false};
                                        });
                                    }}
                                    onConfirm={onSelected}
                                />
                            }

                            <div className="row">
                                <div className="mb-3 col-12">
                                    <FormLabel htmlFor="idTipoControlador" required>Tipo de controlador</FormLabel>
                                    <InputEntidad
                                        name="idTipoControlador"
                                        tipName={TIPS.NAME.MODALS.TIPO_CONTROLADOR_MODAL}
                                        placeholder=""
                                        className={`form-control ${errorOf('idTipoControlador') ? 'is-invalid' : ''}`}
                                        value={formValues.idTipoControlador}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                        title="Tipo de controlador"
                                        entidad="TipoControlador"
                                        onFormat={(row) => (row) ? `${row.codigo} - ${row.nombre}` : ''}
                                        filter={(row) => (row.email || row.direccion) && !tipoControladorEnUso.includes(row.id)}
                                        onUpdate={ValidateTipoControlador}
                                    />
                                    <FormError message={errorOf('idTipoControlador')} />
                                </div>

                                {tipoControladorState.isValidTipoControlador && !tipoControladorState.isEmail &&
                                    <div className="mb-3 col-12">
                                        <DireccionForm
                                            id="ZonaEntrega_direccion"
                                            data={{
                                                entity: formValues.direccion
                                            }}
                                            disabled={props.disabled}
                                            initFormEdit={(state.entity.direccion.id === 0 && state.entity.direccion.latitud === 0 && state.entity.direccion.longitud === 0)}
                                        />
                                    </div>
                                }

                                {tipoControladorState.isValidTipoControlador && tipoControladorState.isEmail &&
                                    <div className="mb-3 col-12">
                                        <FormLabel htmlFor="email" required>Email</FormLabel>
                                        <input
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className={`form-control ${errorOf('email') ? 'is-invalid' : ''}`}
                                            value={formValues.email}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                        <FormError message={errorOf('email')} />
                                    </div>
                                }

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de zona entrega"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_ZONA_ENTREGA_MODAL}
                                            processKey={props.processKey}
                                            entidad="ZonaEntrega"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
                </>)}
                footer={!props.disabled ? (<>
                                {tipoControladorState.isValidTipoControlador && !tipoControladorState.isEmail &&
                                    <button className="btn back-button" data-dismiss="modal"
                                            onClick={(event) => handleClickDireccionesRelacionadas()}>Direcciones
                                        relacionadas
                                    </button>
                                }
                                <div>
                                    <button className="btn btn-outline-primary" style={{marginRight: '10px'}}
                                            data-dismiss="modal" onClick={(event) => props.onDismiss()}>Cancelar
                                    </button>
                                    <button className="btn btn-primary" data-dismiss="modal"
                                            onClick={(event) => handleClickAceptar()}>Aceptar
                                    </button>
                                </div>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : (tipoControladorState.isValidTipoControlador && !tipoControladorState.isEmail ? 'd-flex justify-content-between' : '')}
            />

        </>
    );
}

ZonaEntregaModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ZonaEntregaModal.defaultProps = {
    disabled: false
};

export default ZonaEntregaModal;